import { render } from "./GetUrlsForShow.vue?vue&type=template&id=3e7ab33e"
import script from "./GetUrlsForShow.vue?vue&type=script&lang=js"
export * from "./GetUrlsForShow.vue?vue&type=script&lang=js"
script.render = render

export default script